<script>
    import R, {LOADER} from "../lib/requests";
    // import app from "../stores/app";
    import passportsStore from "../stores/passportsStore";
    import {formatDate, nl2br, statusIn} from "../lib/lib";
    import {
        ORDER_STATUS,
        PASSPORT_PRODUCT_ID,
        PAYMENT_METHOD,
        SHIPPING_METHOD,
        PASSPORT_STATUS
    } from "../lib/constants";
    import Modal from '../components/modal/Modal.svelte';
    import Checkbox from "../components/controls/Checkbox.svelte";
    import Notifier from "../stores/notifier";
    import Alert from "../stores/alerts";
    import OrderPassports from "./OrderPassports.svelte";

    export let orderId = null;
    export let closeCallback;

    let order = null;
    let couriers = [];
    let sendResponseMail = 0;
    let address = '';
    let orderPassportQuantity = 0;
    // let returnPassports = 0;
    let showStatusNew = true;
    let error = null;

    let showPassports = false;

    const paymentMethods = {
        0: "Πιστωτική / Χρεωστική Κάρτα",
        1: "Αντικαταβολή",
        2: "Τραπεζική Κατάθεση"
    }

    const load = () => {

        const onSuccess = result => {
            order = result.order;
            couriers = result.couriers;

            order.status_id = ~~order.status_id;
            order.products.map(item => {
                item.total_price = ~~item.quantity * parseFloat(item.price);
                if (item.id == PASSPORT_PRODUCT_ID) {
                    orderPassportQuantity = ~~item.quantity;
                }
            });
            if (!order.courier_id) {
                order.courier_id = '';
            }

            address = order.address;
            if (order.postal_code) {
                address += (address ? ", " : "") + order.postal_code;
            }
            if (order.city) {
                address += (order.postal_code ? " " : "") + order.city;
            }

            if (order.passports.length) {
                showStatusNew = false;
            }
        };

        const onFailure = err => {
        };

        R.handle(R.order.details, orderId, onSuccess, onFailure, LOADER.POPUP);
    };


    const save = () => {
        const onSuccess = result => {
            Notifier.showMessage("Η παραγγελία ενημερώθηκε");
            if (sendResponseMail === 0) {
                close(order);
            } else {
                sendMail();
            }
        }

        const onFailure = err => {
            // if (err.message) {
            //     Notifier.showError(err.message);
            //     if (err.code == 'user_account_exist') {
            //         setFocusTo("userEmail");
            //     }
            // }
        };

        // Check for correct order and passport statuses
        let error = null;
        if (statusIn(order.status_id, [ORDER_STATUS.COMPLETED, ORDER_STATUS.RETURNED, ORDER_STATUS.CANCELED])) {
            if (order.passports && order.passports.length) {
                order.passports.map(chunk => {
                    if (chunk.status == PASSPORT_STATUS.ASSIGN) {
                        error = "Δεν μπορείτε να αλλάξετε την κατάσταση της παραγγελίας αν δεν γίνει η ανάθεση των διαβατηρίων!";
                    }
                });
            }
        }

        if (error) {
            Alert.warning("Ενημέρωση παραγγελίας", error);
            return;
        }

        R.handle(R.order.edit, order, onSuccess, onFailure, LOADER.POPUP);
    }


    const sendMail = () => {
        const onSuccess = result => {
            Notifier.showMessage("Το μέλος ενημερώθηκε για την κατάσταση της παραγγελίας του");
            close(order);
        }

        const onFailure = err => {
            Alert.warning("Αποστολή Email", "Δεν ήταν δυνατή η αποστολή email στο μέλος!");
        };

        R.handle(R.order.sendMail, order.id, onSuccess, onFailure, LOADER.POPUP);
    }

    const onStatusChange = () => {
        if (order.status_id == ORDER_STATUS.ON_PAYMENT || order.status_id == ORDER_STATUS.RETURNED) {
            sendResponseMail = 0;
        }
    }

    const close = (param) => {
        order = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    load();
</script>


{#if order}
    <Modal modalMd title="Στοιχεία Παραγγελίας" on:close="{ close }">
        <div slot="body">
            <h5 class="mb-3">{ order.lastname } { order.firstname }</h5>
            <div class="row">
                <div class="col-xl-6">

                    <table class="table mb-4">
                        <tbody>
                        <tr>
                            <td class="ps-0">Κωδ. Παραγγελίας:</td>
                            <td class="text-gray">{ order.ref_id }</td>
                        </tr>
                        <tr>
                            <td class="ps-0">Τρόπος Πληρωμής:</td>
                            <td class="text-gray">{ paymentMethods[order.payment_method] }</td>
                        </tr>
                        {#if order.payment_method == PAYMENT_METHOD.CARD}
                            <tr>
                                <td class="ps-0">Κωδ. Πληρωμής:</td>
                                <td class="text-gray">{ order.payment_id }</td>
                            </tr>
                        {/if}
                        <tr>
                            <td class="ps-0">Ημερομηνία:</td>
                            <td class="text-gray">{ formatDate(order.created_at, 'd-m-y H:i') }</td>
                        </tr>
                        {#if order.member}
                            <tr>
                                <td class="ps-0">Α.Μ. Μέλους:</td>
                                <td class="text-gray">{ order.member.code }</td>
                            </tr>
                            <tr>
                                <td class="ps-0">Α.Φ.Μ.:</td>
                                <td class="text-gray">{ order.member.afm }</td>
                            </tr>
                        {/if}
                        <tr>
                            <td class="ps-0">Τηλέφωνο:</td>
                            <td class="text-gray">{ order.phone }</td>
                        </tr>
                        <tr>
                            <td class="ps-0">Email:</td>
                            <td class="text-gray">{ order.email }</td>
                        </tr>
                        <tr>
                            <td class="ps-0">Νομός:</td>
                            <td class="text-gray">
                                {#if order.region}
                                    { order.region.name }
                                {/if}
                            </td>
                        </tr>
                        {#if order.shipping_method == SHIPPING_METHOD.COURIER}
                            <tr>
                                <td class="ps-0">Διεύθυνση:</td>
                                <td class="text-gray">
                                    { address }
                                </td>
                            </tr>
                        {:else}
                            <tr>
                                <td class="ps-0" colspan="2">Παραλαβή από τα γραφεία</td>
                            </tr>
                        {/if}
                        {#if order.bill_afm}
                            <tr>
                                <td colspan="2" class="ps-0"><b>Στοιχεία Τιμολογίου</b></td>
                            </tr>
                            <tr>
                                <td class="ps-0">Επωνυμία:</td>
                                <td class="text-gray">
                                    { order.bill_name }
                                </td>
                            </tr>
                            <tr>
                                <td class="ps-0">Διεύθυνση:</td>
                                <td class="text-gray">
                                    { order.bill_address }
                                </td>
                            </tr>
                            <tr>
                                <td class="ps-0">Τηλέφωνο:</td>
                                <td class="text-gray">
                                    { order.bill_phone }
                                </td>
                            </tr>
                            <tr>
                                <td class="ps-0">Α.Φ.Μ. - Δ.Ο.Υ:</td>
                                <td class="text-gray">
                                    { order.bill_afm } { order.bill_doy }
                                </td>
                            </tr>
                        {/if}
                        {#if order.notes}
                            <tr>
                                <td colspan="2" class="ps-0">
                                    <div class="small fw-bold">Σημειώσεις</div>
                                    <div class="text-gray">
                                        {@html nl2br(order.notes) }
                                    </div>
                                </td>
                            </tr>
                        {/if}
                        {#if order.shipping_method == SHIPPING_METHOD.COURIER}
                            <tr>
                                <td class="input-td ps-0">Courier</td>
                                <td>
                                    <select class="form-select" bind:value="{ order.courier_id }">
                                        <option value="">επιλογή</option>
                                        {#each couriers as courier}
                                            <option value="{ courier.id }">{ courier.name }</option>
                                        {/each}
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td class="input-td ps-0">Κωδ. αποστολής</td>
                                <td>
                                    <input type="text" class="form-control" bind:value="{ order.shipping_code }">
                                </td>
                            </tr>
                        {/if}
                        </tbody>
                    </table>

                    <div class="form-group">
                        <label>Σημειώσεις διαχειριστή</label>
                        <textarea class="form-control" bind:value="{ order.admin_notes }"></textarea>
                    </div>
                </div>
                <div class="col-xl-6">
                    <table class="table mb-4">
                        <thead>
                        <tr>
                            <th>Προϊόν</th>
                            <th>Ποσότ.</th>
                            <th class="text-end">Τιμή</th>
                        </tr>
                        </thead>
                        <tbody>
                        {#each order.products as product}
                            <tr>
                                <td>{ product.name }</td>
                                <td class="text-gray text-center">{ product.quantity }</td>
                                <td class="text-gray text-end">{ product.total_price.toFixed(2) } €</td>
                            </tr>
                        {/each}
                        <tr>
                            <td colspan="2">Μερικό σύνολο</td>
                            <td class="text-end">{ order.products_price } €</td>
                        </tr>
                        {#if order.shipping_price > 0}
                            <tr>
                                <td colspan="2">Μεταφορικά</td>
                                <td class="text-end">{ order.shipping_price } €</td>
                            </tr>
                        {/if}
                        {#if order.cod_price > 0}
                            <tr>
                                <td colspan="2">Έξοδα αντικαταβολής</td>
                                <td class="text-end">{ order.cod_price } €</td>
                            </tr>
                        {/if}
                        {#if order.vat_price > 0}
                            <tr>
                                <td colspan="2">Φ.Π.Α. ({ order.vat }%)</td>
                                <td class="text-end">{ order.vat_price } €</td>
                            </tr>
                        {/if}
                        <tr>
                            <td colspan="2">Σύνολο</td>
                            <td class="text-end fw-bold">{ order.total_price } €</td>
                        </tr>
                        </tbody>
                    </table>

                    <div class="mb-4">
                        <div class="legend py-1 mb-1">Κατάσταση παραγγελίας</div>
                        <div class="form-group">
                            <select class="form-select" bind:value={ order.status_id } on:change={ onStatusChange }>
                                {#if order.status_id == ORDER_STATUS.ON_PAYMENT}
                                    <option value="{ ORDER_STATUS.ON_PAYMENT }">ΑΝΑΜΟΝΗ ΓΙΑ ΠΛΗΡΩΜΗ</option>
                                {/if}
                                {#if showStatusNew}
                                    <option value="{ ORDER_STATUS.NEW }">ΝΕΑ</option>
                                {/if}
                                <option value="{ ORDER_STATUS.ON_PROGRESS }">ΣΕ ΕΞΕΛΙΞΗ</option>
                                <option value="{ ORDER_STATUS.SENT }">ΑΠΕΣΤΑΛΗ</option>
                                <option value="{ ORDER_STATUS.COMPLETED }">ΟΛΟΚΛΗΡΩΘΗΚΕ</option>
                                <option value="{ ORDER_STATUS.RETURNED }">ΕΠΙΣΤΡΑΦΗΚΕ</option>
                                <option value="{ ORDER_STATUS.CANCELED }">ΑΚΥΡΩΘΗΚΕ</option>
                                {#if order.status_id == ORDER_STATUS.FAILED}
                                    <option value="{ ORDER_STATUS.FAILED }">ΑΠΕΤΥΧΕ</option>
                                {/if}
                            </select>
                        </div>
                        {#if order.status_id != ORDER_STATUS.ON_PAYMENT && order.status_id != ORDER_STATUS.RETURNED}
                            <Checkbox label="Αποστολή απαντητικού email στον πελάτη"
                                      bind:checked="{ sendResponseMail }"/>
                        {/if}
                    </div>

                    {#if orderPassportQuantity > 0}
                        <OrderPassports statusId="{ order.status_id }"
                                        maxQuantity="{ orderPassportQuantity }" bind:passports={order.passports}/>
                    {/if}
                    <!--{#if order.passports}-->

                    <!--                        <div class="legend py-1 mb-1">-->
                    <!--                            Αρ. Διαβατηρίων-->
                    <!--                        </div>-->
                    <!--                        <div class="row">-->
                    <!--                            <div class="col-6 mb-2">-->
                    <!--                                <div class="form-control input-info form-item">-->
                    <!--                                    { $passportsStore.prefix }{ order.passports.passport_from }-->
                    <!--                                    <div class="form-item-info top">Από</div>-->
                    <!--                                </div>-->
                    <!--                            </div>-->
                    <!--                            <div class="col-6 mb-2">-->
                    <!--                                <div class="form-control input-info form-item">-->
                    <!--                                    { $passportsStore.prefix }{ order.passports.passport_to }-->
                    <!--                                    <div class="form-item-info top">Έως</div>-->
                    <!--                                </div>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                        <div class:text-danger={ order.passports.status == PASSPORT_STATUS.RETURNED || order.passports.status == PASSPORT_STATUS.DESTROYED }>-->
                    <!--                            { passportStatus(order.passports.status) }-->
                    <!--                        </div>-->
                    <!--                        {#if (order.status_id == ORDER_STATUS.RETURNED || order.status == ORDER_STATUS.CANCELED) && order.passports.status == PASSPORT_STATUS.ASSIGNED}-->
                    <!--                            <Checkbox label="Να επιστραφούν τα διαβατήρια της παραγγελίας"-->
                    <!--                                      bind:checked="{ returnPassports }" cssClass="mt-3"/>-->
                    <!--                        {/if}-->
                    <!--{:else}-->
                    <!--    {#if order.status_id != ORDER_STATUS.NEW && orderPassportQuantity > 0}-->
                    <!--        <button class="btn btn-default btn-block" on:click={ openPassports }>-->
                    <!--            ΟΡΙΣΜΟΣ ΔΙΑΒΑΤΗΡΙΩΝ-->
                    <!--        </button>-->
                    <!--    {/if}-->
                    <!--{/if}-->
                </div>
            </div>
            {#if error}
                <div class="alert alert-danger mt-3">
                    { error }
                </div>
            {/if}
            <hr>
            <div class="text-end">
                <div class="btn btn-link me-4" on:click="{ () => close() }">Κλείσιμο</div>
                <button class="btn btn-primary px-4" on:click="{ save }">ΕΝΗΜΕΡΩΣΗ</button>
            </div>
        </div>
    </Modal>
{/if}

<style>
    .table tbody tr:last-child td {
        border-bottom: none;
    }

    .input-td {
        vertical-align: middle;
    }
</style>